import { intlLocale } from './locale';

/** The first day of the week everywhere in the console (calendar, plan day chips, every date picker): Sunday, as in Saudi Arabia. 0 = Sunday. */
export const FIRST_DAY_OF_WEEK = 0;

function names(locale: string, options: Intl.DateTimeFormatOptions, count: number, at: (index: number) => Date): string[] {
  const format = new Intl.DateTimeFormat(locale, { ...options, timeZone: 'UTC' });
  return Array.from({ length: count }, (_, i) => format.format(at(i)));
}

/**
 * PrimeNG's date-picker texts for a locale, from Intl so the month and day names follow the app locale (Arabic names, Latin digits via
 * `ar-u-nu-latn`, the same locale string every other date in the console uses). Days start at Sunday, matching `FIRST_DAY_OF_WEEK`.
 */
export function primeNgDateTranslation(lang: string) {
  const locale = intlLocale(lang);
  // 2023-01-01 was a Sunday.
  const day = (i: number) => new Date(Date.UTC(2023, 0, 1 + i));
  const month = (i: number) => new Date(Date.UTC(2023, i, 1));
  return {
    firstDayOfWeek: FIRST_DAY_OF_WEEK,
    dayNames: names(locale, { weekday: 'long' }, 7, day),
    dayNamesShort: names(locale, { weekday: 'short' }, 7, day),
    dayNamesMin: names(locale, { weekday: 'narrow' }, 7, day),
    monthNames: names(locale, { month: 'long' }, 12, month),
    monthNamesShort: names(locale, { month: 'short' }, 12, month),
    today: lang === 'ar' ? 'اليوم' : 'Today',
    clear: lang === 'ar' ? 'مسح' : 'Clear',
    weekHeader: lang === 'ar' ? 'أسبوع' : 'Wk',
    am: lang === 'ar' ? 'ص' : 'AM',
    pm: lang === 'ar' ? 'م' : 'PM',
    // Every p-select / p-multiselect with nothing to show ("No results found" in English, whatever the language).
    emptyMessage: lang === 'ar' ? 'لا توجد نتائج' : 'No results found',
    emptyFilterMessage: lang === 'ar' ? 'لا توجد نتائج' : 'No results found',
    dateFormat: 'yy-mm-dd'
  };
}
